import { Component } from "@angular/core";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { Platform, AlertController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import {
  InAppBrowser,
  InAppBrowserOptions,
} from "@ionic-native/in-app-browser/ngx";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { HistoryHelperService } from "./utils/history-helper.service";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";

import { environment } from "../environments/environment";
import { LanguageService } from "./services/language/language.service";
import { TranslateProvider } from "./services/language/translate.provider";
import { AuthService } from "./services/auth.service";
import { UtilService } from "./services/util";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: [
    "./side-menu/styles/side-menu.scss",
    "./side-menu/styles/side-menu.shell.scss",
    "./side-menu/styles/side-menu.responsive.scss",
  ],
})
export class AppComponent {
  savedLang = "";
  textDir = "ltr";
  availableLanguages = [];
  userName = "OSO2 User";
  userID = "VN2198877168";
  userRoles = 16;
  userImg;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private storage: Storage,
    private inAppBrowser: InAppBrowser,
    public translate: TranslateService,
    public historyHelper: HistoryHelperService,
    public languageService: LanguageService,
    public myTranslate: TranslateProvider,
    public alertController: AlertController,
    private auth: AuthService,
    private util: UtilService,
    private screenOrientation: ScreenOrientation
  ) {
    console.log("AppComponent");
    const self = this;
    const tempLang = environment.defaultLanguage || "vn";
    // this language will be used as a fallback when a translation isn't found in the current language
    self.translate.setDefaultLang(tempLang);
    self.platform.ready().then(() => {
      console.log("AppComponent Ready");
      if (self.platform.is("hybrid")) {
        // set to portrait
        this.screenOrientation.lock(
          this.screenOrientation.ORIENTATIONS.PORTRAIT
        );
        self.statusBar.styleLightContent();
        self.statusBar.backgroundColorByHexString("#008478");
        self.splashScreen.hide();
      }
      self.setLanguage();
    });
    self.auth.userProfile$.subscribe((val: any) => {
      if (val && val.name) {
        self.userName = val.name;
      }
      let temp = self.auth.getUserUID();
      if (temp != "") {
        self.userID = temp;
      }
      self.userRoles = self.auth.getUserRoles();
    });
    self.auth.userData$.subscribe((val: any) => {
      self.userImg = self.auth.getUserImg();
    });
  }

  isProf() {
    if ((this.userRoles & 32) || (this.userRoles & 64)) {
      return true;
    }
    return false;
  }

  setLanguage() {
    const self = this;
    self.storage
      .get("language")
      .then((language) => {
        let tempLang = environment.defaultLanguage || "vn";
        self.savedLang = language;
        if (language) {
          tempLang = language;
        }
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        self.translate.use(tempLang);
      })
      .catch((error) => {});
    // this is to determine the text direction depending on the selected language
    // for the purpose of this example we determine that only arabic and hebrew are RTL.
    this.translate.onLangChange.subscribe(async (event: LangChangeEvent) => {
      const tempLang = self.translate.currentLang;
      console.log("Newlang: " + tempLang + "; Oldlang:" + self.savedLang);
      if (self.savedLang !== tempLang) {
        self.savedLang = tempLang;
        try {
          await self.storage.set("language", tempLang);
        } catch (err) {}
      }
      self.translate.getTranslation(tempLang).subscribe((translations) => {
        console.log("updated translations");
        self.myTranslate.setTranslations(translations);
        self.languageService.setCurrentLang(tempLang);
      });
    });
  }

  async openLanguageChooser() {
    const self = this;
    self.availableLanguages = self.languageService
      .getLanguages()
      .map((item) => ({
        name: item.name,
        type: "radio",
        label: item.name,
        value: item.code,
        checked: item.code === self.translate.currentLang,
      }));

    const alert = await self.alertController.create({
      header: self.myTranslate.get("SELECT_LANGUAGE"),
      inputs: self.availableLanguages,
      cssClass: "language-alert",
      buttons: [
        {
          text: self.myTranslate.get("CANCEL"),
          role: "cancel",
          cssClass: "secondary",
          handler: () => {},
        },
        {
          text: self.myTranslate.get("OK"),
          handler: (data) => {
            console.log(data);
            if (data) {
              self.translate.use(data);
            }
          },
        },
      ],
    });
    await alert.present();
  }

  gotoOSO2(mode) {
    const options: InAppBrowserOptions = {
      zoom: "yes",
      enableViewportScale: "yes",
    };
    let baseUrl, lang, url;
    if (mode == 2) {
      //"shop"
      baseUrl = "http://oso2.com.au/";
      if (this.savedLang == "en") {
        lang = "en";
      } else {
        lang = "vi";
      }
      url = baseUrl + lang;
    } else {
      baseUrl = "http://oso2.com/";
      if (this.savedLang == "en") {
        lang = "UK";
      } else {
        lang = "VN";
      }
      url =
        baseUrl +
        lang +
        "/MElearning.aspx?" +
        "serial=" +
        this.util.sbpmDevice$.getValue().serialNum +
        "&UID=" +
        this.userID +
        "&appType=MOB" +
        "&AspxAutoDetectCookieSupport=1";
      console.log(url);
    }

    // Opening a URL and returning an InAppBrowserObject
    const browser = this.inAppBrowser.create(url, "_system", options);
  }
}
